import $ from "jquery";

// CSP-Dispatcher: Statt eines Inline-`var gui = new DavidErz.GuiX()` pro Seite traegt die
// View ihren Gui-Klassennamen deklarativ als <body data-gui="GuiX"> (gesetzt via
// ViewData["Gui"]). Hier wird er beim DOM-Ready aufgeloest und instanziiert. Damit
// entfaellt jedes Inline-Script und script-src kann ohne 'unsafe-inline' auskommen.
$(function () {
    const name = document.body.dataset.gui;
    if (!name) {
        return;
    }

    const registry = (window as unknown as { DavidErz?: Record<string, unknown> }).DavidErz ?? {};
    const ctor = registry[name];

    if (typeof ctor === "function") {
        (window as unknown as { gui?: unknown }).gui = new (ctor as new () => unknown)();
    } else {
        console.warn(`Unbekannte Gui-Klasse in data-gui: ${name}`);
    }
});
